export default "__VITE_ASSET__612ef7ed__"